import * as Scrivito from "scrivito";
import htmlOptions from "^/utils/htmlOptions";
import textWidgetIcon from "../../assets/images/text_widget.svg";

Scrivito.provideEditingConfig("TextWidget", {
  title: "Text",
  thumbnail: textWidgetIcon,
  attributes: {
    alignment: {
      title: "Alignment",
      description: "Default: Left",
      values: [
        { value: "left", title: "Left" },
        { value: "center", title: "Center" },
        { value: "right", title: "Right" },
      ],
    },
    text: {
      title: "Text",
      description: "The actual source code of this text",
      options: htmlOptions,
    },
  },
  properties: ["alignment", "text"],
  initialContent: {
    alignment: "left",
  },

  validations: [
    [
      "text",
      (text) => {
        const isStylePresent = text.includes("<style>");
        if (isStylePresent) {
          return {
            message:
              "HTML <style> tag has been added to Text HTML content. It can cause problems with the page styling. Please consider removing it.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
